import CachedIcon from '@mui/icons-material/Cached';
import RefreshIcon from '@mui/icons-material/Refresh';

// CP-5556 (Martina, 10/5): one circle with an arrow means Replace; two arrows mean Refresh/Reload.
// MUI's names point the other way (its "Refresh" glyph is the single arrow), so import these
// instead of the MUI icons and the meaning can't drift again.
export { default as UploadIcon } from '@mui/icons-material/Upload'; // arrow over a bar
export const ReplaceIcon = RefreshIcon;
export const ReloadIcon = CachedIcon;
